import { render } from "./UnlockDialog.vue?vue&type=template&id=b65db988&scoped=true&ts=true"
import script from "./UnlockDialog.vue?vue&type=script&lang=ts"
export * from "./UnlockDialog.vue?vue&type=script&lang=ts"

import "./UnlockDialog.vue?vue&type=style&index=0&id=b65db988&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b65db988"]])

export default __exports__